import { useState, useEffect } from 'react';
import Typewriter from 'typewriter-effect';

interface TerminalIntroProps {
  onComplete: () => void;
}

const TerminalIntro: React.FC<TerminalIntroProps> = ({ onComplete }) => {
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  useEffect(() => {
    if (isTypingComplete) {
      const timer = setTimeout(() => {
        onComplete();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isTypingComplete, onComplete]);

  return (
    <div className="fixed inset-0 bg-dev-bg flex items-center justify-center z-50">
      <div className="w-full max-w-4xl p-8">
        <div className="bg-dev-bg-card rounded-xl border border-dev-border shadow-dev-lg overflow-hidden">
          {/* Terminal Header */}
          <div className="bg-dev-bg-light border-b border-dev-border px-4 py-3 flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-red-500"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
            <span className="ml-4 text-dev-text-dimmed font-mono text-sm">terminal</span>
          </div>
          
          {/* Terminal Content */}
          <div className="p-6 font-mono">
            <div className="mb-3">
              <span className="text-dev-accent">parth@portfolio</span>
              <span className="text-dev-text-muted">:</span>
              <span className="text-dev-accent-cyan">~/Developer</span>
              <span className="text-dev-text-muted">$</span>
            </div>
            <div className="flex items-center">
              <span className="text-dev-text-muted mr-2">&gt;</span>
              <div className="text-green-500">
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter
                      .typeString('cd parthkohale.com')
                      .pauseFor(300)
                      .callFunction(() => {
                        setIsTypingComplete(true);
                      })
                      .start();
                  }}
                  options={{
                    cursor: '█',
                    delay: 60,
                  }}
                />
              </div>
            </div>
            <div className="mt-2 text-white opacity-0 animate-fade-in" style={{ animationDelay: '1.5s' }}>
              <span className="text-dev-text-dimmed">&gt;</span> Loading portfolio...
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerminalIntro;